import FormBuilder from '@components/Form';
import Page from '@components/PageAuth';
import PageTitle from '@components/PageTitle';
import UserService from '@services/UserService';
import I18n from '@src/i18n';
import styled from '@src/styled-components';
import React from 'react';

import { CodeForm } from '../forms/Code';
import NotificationComponent from '../helpers/_showNotifications';

type PropType = { history: { replace: Function }; match: any; }


class Recover extends React.Component<PropType> {
    private _userSvc = new UserService();

    constructor (props: PropType) {
        super(props);
    }

    render () {
        const Back = () => {
            return (
                this.props.history.replace('/recover')
            )
        }

        const params = new URLSearchParams(location.search);

        const RedefinePassword = async (credentials: { code: string; username: string; password: string }, actions: any) => {
            this.setState({ isLoading: true });
            try {
                await this._userSvc.redefinePassword(credentials.username.trim(), credentials.code.trim(), credentials.password);
                actions.setSubmitting(false);
                this.setState({ isLoading: false });
                NotificationComponent.Notify('success', I18n.l('titles.redefine'), 'Sua senha foi alterada com sucesso');
                this.props.history.replace('/login')

            } catch (e) {
                this.setState({ isLoading: false });
                actions.setSubmitting(false);
                NotificationComponent.Notify('error', I18n.l('titles.redefine'), e);
            }
        }
        return (
            <Page>
                <Content>
                    <PageTitle page="redefine" />
                    <FormBuilder settings={CodeForm} onSubmit={RedefinePassword} onCancel={Back}
                        data={[
                            { name: 'code', value: params.get('code') || "" },
                            { name: 'username', value: params.get('email') || "" },
                        ]}
                    />
                </Content>
            </Page>
        );
    }
}

const Content = styled.div`
    flex: 1;
    display: flex;
    flex-flow: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 50px;`;


export default Recover;
